import React from "react";
import { Box } from "mineral-ui";

const MaxWidth = ({ children }) => (
  <Box
    style={{ maxWidth: "60em" }}
    marginHorizontal="auto"
    paddingHorizontal="sm"
  >
    {children}
  </Box>
);

export default MaxWidth;
